<template>
  <div class="app">
    <!-- 导航栏 -->
    <header class="header" ref="header">
      <div class="container">
        <div class="logo">
          <img src="@/assets/logo.png" alt="轻鸿数智" class="logo-image" />
        </div>
        <button class="mobile-nav-toggle" @click="toggleMobileNav">☰</button>
        <nav class="nav" :class="{ active: mobileNavActive }">
          <ul>
            <li><a href="#home" @click="toggleMobileNav">首页</a></li>
            <li class="dropdown">
              <a href="#company" @click="toggleMobileNav">公司</a>
            </li>
            <li><a href="#news" @click="toggleMobileNav">公司动态</a></li>
            <li><a href="#products" @click="toggleMobileNav">产品</a></li>
            <li><a href="#chips" @click="toggleMobileNav">芯片方案</a></li>
            <li><a href="#cases" @click="toggleMobileNav">案例</a></li>
            <li><a href="#contact" @click="toggleMobileNav">联系我们</a></li>
          </ul>
        </nav>
      </div>
    </header>

    <!-- 首页 Hero 区域 -->
    <section id="home" class="hero">
      <div class="container">
        <div class="hero-content">
          <h1>让智能硬件更有表达</h1>
          <p>开源鸿蒙轻智能 · 构筑下一代物联网体验</p>
          <div class="hero-buttons">
            <button class="btn btn-primary" @click="scrollToSection('products')">探索轻鸿方案</button>
            <button class="btn btn-secondary" @click="scrollToSection('technology')">统一互联</button>
          </div>
        </div>
      </div>
    </section>

    <!-- 企业介绍模块 -->
    <section class="company-intro">
      <div class="container">
        <h2>企业介绍</h2>
        <div class="intro-content">
          <div class="intro-image">
            <div class="carousel-container">
              <div class="carousel-slides">
                <div class="carousel-slide active">
                  <img src="@/assets/images/home/1.png" alt="企业介绍" loading="lazy" />
                </div>
                <div class="carousel-slide">
                  <img src="@/assets/images/home/2.png" alt="企业介绍" loading="lazy" />
                </div>
                <div class="carousel-slide">
                  <img src="@/assets/images/home/3.png" alt="企业介绍" loading="lazy" />
                </div>
              </div>
              <div class="carousel-controls">
                <button class="carousel-prev">‹</button>
                <button class="carousel-next">›</button>
              </div>
              <div class="carousel-indicators">
                <button class="carousel-indicator active" data-index="0"></button>
                <button class="carousel-indicator" data-index="1"></button>
                <button class="carousel-indicator" data-index="2"></button>
              </div>
            </div>
          </div>
          <div class="intro-text">
            <p>武汉轻鸿数智科技有限公司（Lite Smart Ltd）是一家专注于开源鸿蒙（OpenHarmony）轻智能解决方案的技术公司，致力于让智能硬件"更有表达"。公司凭借在开源鸿蒙领域的深厚技术积累，为智能硬件厂商提供从芯片方案、操作系统中间件到应用生态的全栈解决方案，帮助客户快速落地轻智能产品。我们的核心团队来自华为等行业领先企业，拥有丰富的操作系统开发和智能硬件经验，致力于通过技术创新推动智能物联网产业的发展。公司已与多家芯片厂商建立战略合作伙伴关系，成为多个芯片平台在鸿蒙领域的独家代理，为客户提供从芯片选型到产品落地的一站式服务。</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 企业文化模块 -->
    <section id="company" class="company">
      <div class="container">
        <h2>企业文化</h2>
        <div id="vision" class="vision-mission">
          <div class="vision-card">
            <div class="card-icon">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM12 6C10.34 6 9 7.34 9 9C9 10.66 10.34 12 12 12C13.66 12 15 10.66 15 9C15 7.34 13.66 6 12 6ZM12 18C10.34 18 9 16.66 9 15C9 13.34 10.34 12 12 12C13.66 12 15 13.34 15 15C15 16.66 13.66 18 12 18Z" fill="#0C2D4F"/>
              </svg>
            </div>
            <h3>愿景</h3>
            <p>开源鸿蒙轻智能，让智能硬件更有表达</p>
          </div>
          <div class="vision-card">
            <div class="card-icon">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2L2 7L12 12L22 7L12 2ZM2 17L12 22L22 17L12 12L2 17Z" fill="#0C2D4F"/>
              </svg>
            </div>
            <h3>使命</h3>
            <p>立足开源鸿蒙领域，构筑轻智能解决方案竞争力，通过硬件方案、OS中间件、价值应用服务客户</p>
          </div>
          <div class="vision-card">
            <div class="card-icon">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 1L3 5V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V5L12 1ZM12 21C7.72 19.79 5 15.76 5 11V6.3L12 3.15L19 6.3V11C19 15.76 16.28 19.79 12 21Z" fill="#0C2D4F"/>
                <path d="M12 15C13.66 15 15 13.66 15 12C15 10.34 13.66 9 12 9C10.34 9 9 10.34 9 12C9 13.66 10.34 15 12 15Z" fill="#0C2D4F"/>
              </svg>
            </div>
            <h3>价值观</h3>
            <p>以信誉立身、客户价值为本、技术领先、以人为本、社会责任、开放协同、互利共生</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 公司动态模块 -->
    <section id="news" class="company-news">
      <div class="container">
        <h2>公司动态</h2>
        <div class="news-cards" v-if="news.length > 0">
          <div v-for="item in news" :key="item.id" class="news-card">
            <div class="news-date">{{ item.date }}</div>
            <h3>{{ item.title }}</h3>
            <p>{{ item.content }}</p>
            <a :href="item.link" class="news-link">查看详情</a>
          </div>
        </div>
        <div v-else class="news-loading">
          <p>加载中...</p>
        </div>
      </div>
    </section>

    <!-- 产品矩阵模块 -->
    <section id="products" class="product-matrix">
      <div class="container">
        <h2>产品矩阵</h2>
        <div class="product-cards">
          <div class="product-card">
            <div class="product-image">
              <img src="@/assets/images/car.png" alt="二轮车" loading="lazy" />
            </div>
            <h3>二轮车</h3>
            <p>基于匠芯创D211芯片，首次提供二轮车RTOS版端侧地图（高德），主题开发告别C语言。</p>
          </div>
          <div class="product-card">
            <div class="product-image">
              <img src="@/assets/images/watch.png" alt="手表" loading="lazy" />
            </div>
            <h3>手表</h3>
            <p>支持OpenHarmony LiteWearable JS API，提供丰富的生态应用和主题。</p>
          </div>
          <div class="product-card">
            <div class="product-image">
              <img src="@/assets/images/ohapp.png" alt="应用/主题市场" loading="lazy" />
            </div>
            <h3>应用/主题市场</h3>
            <p>LiteSmart Apps应用市场，一次开发多端部署，主题产品（标准+工具+市场）。</p>
          </div>
          <div class="product-card">
            <div class="product-image">
              <img src="@/assets/images/theme_tool.png" alt="IDE工具" loading="lazy" />
            </div>
            <h3>IDE工具</h3>
            <p>主题开发工具所见即所得，DevEco Studio兼容测试套件。</p>
          </div>
          <div class="product-card">
            <div class="product-image">
              <img src="@/assets/images/image.png" alt="AI玩具" loading="lazy" />
            </div>
            <h3>AI玩具</h3>
            <p>支持ASR/TTS，云端大模型接入，提供智能交互体验。</p>
          </div>
          <div class="product-card">
            <div class="product-image">
              <img src="@/assets/images/book.png" alt="电子书" loading="lazy" />
            </div>
            <h3>电子书</h3>
            <p>轻量图形框架，低功耗设计，提供丰富的阅读体验。</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 核心团队模块 -->
    <section id="team" class="core-team">
      <div class="container">
        <h2>核心团队</h2>
        <div class="team-stats">
          <div class="stat-card">
            <div class="stat-number">15+</div>
            <div class="stat-label">研发人员</div>
            <p>多来自华为</p>
          </div>
          <div class="stat-card">
            <div class="stat-number">8</div>
            <div class="stat-label">8年以上OS开发经验</div>
          </div>
          <div class="stat-card">
            <div class="stat-number">研发中心</div>
            <div class="stat-label">武汉</div>
            <p>行业影响力带来人力资源优势</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 产品优势模块 -->
    <section class="product-advantages">
      <div class="container">
        <h2>产品优势</h2>
        <div class="advantage-cards">
          <div class="advantage-card">
            <div class="card-icon">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2L2 7L12 12L22 7L12 2ZM2 17L12 22L22 17L12 12L2 17Z" fill="#0C2D4F"/>
              </svg>
            </div>
            <h3>更轻</h3>
            <p>资源占用轻（200MHz/16MB），减少电池容量</p>
          </div>
          <div class="advantage-card">
            <div class="card-icon">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM12 6C10.34 6 9 7.34 9 9C9 10.66 10.34 12 12 12C13.66 12 15 10.66 15 9C15 7.34 13.66 6 12 6ZM12 18C10.34 18 9 16.66 9 15C9 13.34 10.34 12 12 12C13.66 12 15 13.34 15 15C15 16.66 13.66 18 12 18Z" fill="#0C2D4F"/>
              </svg>
            </div>
            <h3>更省</h3>
            <p>待机时间十倍于安卓</p>
          </div>
          <div class="advantage-card">
            <div class="card-icon">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2L2 7L12 12L22 7L12 2ZM2 17L12 22L22 17L12 12L2 17Z" fill="#0C2D4F"/>
              </svg>
            </div>
            <h3>更智能</h3>
            <p>100+生态应用，支持ASR/TTS，云端大模型接入</p>
          </div>
          <div class="advantage-card">
            <div class="card-icon">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2L2 7L12 12L22 7L12 2ZM2 17L12 22L22 17L12 12L2 17Z" fill="#0C2D4F"/>
              </svg>
            </div>
            <h3>更快</h3>
            <p>开机秒开，高帧率刷新</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 技术架构模块 -->
    <section id="technology" class="technology">
      <div class="container">
        <h2>技术架构</h2>
        <div class="tech-architecture">
          <div class="tech-layers">
            <div class="tech-section">
              <h4>配套工具</h4>
              <div class="tech-items">
                <span>DevEco Studio</span>
                <span>兼容测试套件</span>
                <span>主题工具</span>
              </div>
            </div>
            <div class="tech-section">
              <h4>生态层</h4>
              <div class="tech-items">
                <span>生态主题</span>
                <span>主题框架</span>
                <span>生态应用</span>
                <span>OpenHarmony LiteWearable JS API</span>
              </div>
            </div>
            <div class="tech-section">
              <h4>核心子系统</h4>
              <div class="tech-items">
                <span>OpenHarmony基本能力子系统集</span>
                <span>互联子系统</span>
                <span>运动/健康子系统</span>
              </div>
            </div>
            <div class="tech-section">
              <h4>驱动与内核</h4>
              <div class="tech-items">
                <span>驱动子系统</span>
                <span>Kernel (RTOS/LiteOS)</span>
                <span>芯片 (海思、炬芯、恒玄、思澈等)</span>
              </div>
            </div>
            <div class="tech-section">
              <h4>互联互通</h4>
              <div class="tech-items">
                <span>WatchConnectKit</span>
                <span>Binder</span>
                <span>手机云</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>



    <!-- 芯片解决方案模块 -->
    <section id="chips" class="chip-solutions">
      <div class="container">
        <h2>芯片解决方案</h2>
        <div class="chip-cards">
          <div class="chip-card">
            <h3>思澈 SF32LB56x</h3>
            <ul>
              <li>Arm Cortex-M33 240MHz</li>
              <li>800KB SRAM</li>
              <li>BT5.3</li>
              <li>NPU 1.92GOPS</li>
            </ul>
          </div>
          <div class="chip-card">
            <h3>炬芯 ATS3089S</h3>
            <ul>
              <li>202MHz MCU+DSP</li>
              <li>1168KB SRAM</li>
              <li>2D+2.5D GPU</li>
              <li>12μA/MHz</li>
              <li>BT5.4</li>
            </ul>
          </div>
          <div class="chip-card">
            <h3>海思 W610</h3>
            <ul>
              <li>双CPU+GPU+DSP 4Core</li>
              <li>AMOLED 60Hz</li>
              <li>DVFS低功耗</li>
            </ul>
          </div>
          <div class="chip-card">
            <h3>匠芯创 D21X</h3>
            <ul>
              <li>RISC-V 64bits</li>
              <li>2.5D图形加速</li>
              <li>H.264</li>
              <li>安全引擎</li>
            </ul>
          </div>
        </div>
        <p class="chip-note">开发板及开源鸿蒙代码已开放</p>
      </div>
    </section>

    <!-- 应用生态模块 -->
    <section class="app-ecosystem">
      <div class="container">
        <h2>应用生态</h2>
        <div class="ecosystem-content">
          <div class="ecosystem-stats">
            <div class="ecosystem-image" @click="openImageModal('@/assets/images/ohlitemarket.png')">
              <img src="@/assets/images/ohlitemarket.png" alt="应用生态" loading="lazy" />
              <div class="image-overlay">
                <span class="zoom-icon">+</span>
              </div>
            </div>
            <div class="stat-number">70+</div>
            <div class="stat-label">应用持续增加</div>
          </div>
          <div class="ecosystem-features">
            <h3>特色</h3>
            <ul>
              <li>应用市场 LiteSmart Apps，一次开发多端部署</li>
              <li>主题产品（标准+工具+市场）</li>
              <li>主题开发工具所见即所得</li>
              <li>IDE及社区支持</li>
            </ul>
            <div class="app-market-link">
              <a href="https://www.openwearplay.com/" target="_blank" class="btn btn-primary">访问应用市场</a>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 图片模态框 -->
    <div v-if="imageModalVisible" class="image-modal" @click="closeImageModal">
      <div class="modal-content" @click.stop>
        <button class="close-btn" @click="closeImageModal">&times;</button>
        <img :src="modalImageSrc" :alt="'放大图片'" class="modal-image" />
      </div>
    </div>

    <!-- 典型案例模块 -->
    <section id="cases" class="case-studies">
      <div class="container">
        <h2>典型案例</h2>
        <div class="case-cards">
          <div class="case-card">
            <div class="case-image">
              <img src="@/assets/images/xufeiluyingbi.png" alt="录音笔" loading="lazy" />
            </div>
            <h3>录音笔</h3>
            <p>基于炬芯3089 SOC，搭载轻鸿数智方案，提供JS应用生态，对接纯血鸿蒙手机。通过轻智能解决方案，实现了更轻、更省、更智能的录音体验，支持实时转写、语音识别等AI功能。</p>
          </div>
          <div class="case-card">
            <div class="case-image">
              <img src="@/assets/images/run.png" alt="二轮车" loading="lazy" />
            </div>
            <h3>二轮车</h3>
            <p>基于匠芯创D211芯片，首次提供二轮车RTOS版端侧地图（高德），主题开发告别C语言。轻鸿数智方案为二轮车带来了智能仪表、导航定位、远程控制等功能，提升了骑行体验。</p>
          </div>
          <div class="case-card">
            <h3>海思平台</h3>
            <p>轻鸿数智方案提供丰富图形化界面、录音AI服务，为海思平台设备带来了更智能的用户体验和更高效的系统性能。</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 核心技术/独特优势模块 -->
    <section class="core-tech">
      <div class="container">
        <h2>核心技术/独特优势</h2>
        <div class="tech-grid">
          <div class="tech-item">
            <h3>极简内核，存储占用优化</h3>
          </div>
          <div class="tech-item">
            <h3>图形引擎，多端适配</h3>
          </div>
          <div class="tech-item">
            <h3>安全互联，统一互联协议</h3>
          </div>
          <div class="tech-item">
            <h3>低功耗框架，十倍待机</h3>
          </div>
          <div class="tech-item">
            <h3>生态兼容，百款应用</h3>
          </div>
          <div class="tech-item">
            <h3>主题工具链，所见即所得</h3>
          </div>
          <div class="tech-item">
            <h3>深度参与统一互联，PMC贡献</h3>
          </div>
          <div class="tech-item">
            <h3>芯片鸿蒙独家代理，快速落地</h3>
          </div>
          <div class="tech-item">
            <h3>武汉·深圳双研发中心</h3>
          </div>
        </div>
      </div>
    </section>

    <!-- 荣誉资质模块 -->
    <section id="honors" class="honors">
      <div class="container">
        <h2>荣誉资质</h2>
        <div class="honor-grid">
          <div class="honor-item">
            <div class="honor-image">
              <img src="@/assets/images/z1.png" alt="XTS认证 & 统一互联认证数量领先" loading="lazy" />
            </div>
            <h3>XTS认证 & 统一互联认证数量领先</h3>
          </div>
          <div class="honor-item">
            <div class="honor-image">
              <img src="@/assets/images/z2.png" alt="统一互联PMC根技术贡献单位" loading="lazy" />
            </div>
            <h3>统一互联PMC根技术贡献单位</h3>
          </div>
          <div class="honor-item">
            <div class="honor-image">
              <img src="@/assets/images/o2.png" alt="开源鸿蒙开发者大会/技术大会主题演讲嘉宾" loading="lazy" />
            </div>
            <h3>开源鸿蒙开发者大会/技术大会主题演讲嘉宾</h3>
          </div>
          <div class="honor-item">
            <div class="honor-image">
              <img src="@/assets/images/z4.png" alt="华为HDD授课老师" loading="lazy" />
            </div>
            <h3>华为HDD授课老师</h3>
          </div>
          <div class="honor-item">
            <div class="honor-image">
              <img src="@/assets/images/open.png" alt="2024年度开源鸿蒙社区先锋单位" loading="lazy" />
            </div>
            <h3>2024年度开源鸿蒙社区先锋单位</h3>
          </div>
          <div class="honor-item">
            <div class="honor-image">
              <img src="@/assets/images/giic.png" alt="全球智慧物联网联盟(GIIC)会员" loading="lazy" />
            </div>
            <h3>全球智慧物联网联盟(GIIC)会员</h3>
          </div>
          <div class="honor-item">
            <div class="honor-image">
              <img src="@/assets/images/z1.png" alt="统一互联先锋专家" loading="lazy" />
            </div>
            <h3>统一互联先锋专家</h3>
          </div>
          <div class="honor-item">
            <div class="honor-image">
              <img src="@/assets/images/z1.png" alt="统一互联非凡伙伴" loading="lazy" />
            </div>
            <h3>统一互联非凡伙伴</h3>
          </div>
          <div class="honor-item">
            <div class="honor-image">
              <img src="@/assets/images/z1.png" alt="多家芯片鸿蒙领域独家代理伙伴" loading="lazy" />
            </div>
            <h3>多家芯片鸿蒙领域独家代理伙伴</h3>
          </div>
        </div>
      </div>
    </section>

    <!-- 联系我们模块 -->
    <section id="contact" class="contact">
      <div class="container">
        <h2>联系我们</h2>
        <div class="contact-content">
          <div class="contact-cards">
            <div class="contact-card">
              <div class="card-icon">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20 4H4C2.89543 4 2 4.89543 2 6V18C2 19.1046 2.89543 20 4 20H20C21.1046 20 22 19.1046 22 18V6C22 4.89543 21.1046 4 20 4ZM20 8L12 13L4 8V6L12 11L20 6V8Z" fill="#1C6FB4"/>
                </svg>
              </div>
              <h3>邮箱</h3>
              <p>wangcongding@lite-smart.com</p>
              <a href="mailto:wangcongding@lite-smart.com" class="contact-link">发送邮件</a>
            </div>
            <div class="contact-card">
              <div class="card-icon">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 11.5C12.8284 11.5 13.5 10.8284 13.5 10C13.5 9.17157 12.8284 8.5 12 8.5C11.1716 8.5 10.5 9.17157 10.5 10C10.5 10.8284 11.1716 11.5 12 11.5ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z" fill="#1C6FB4"/>
                </svg>
              </div>
              <h3>地址</h3>
              <p>武汉：湖北省武汉市东湖新技术开发区高新大道999号未来科技城海外人才大楼B4-608室</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 底部信息 -->
    <footer class="footer">
      <div class="container">
        <div class="footer-content">
          <div class="footer-section">
            <h3>武汉轻鸿数智科技有限公司</h3>
            <p>Lite Smart Ltd</p>
            <p>Lite is Valuable</p>
          </div>
          <div class="footer-section">
            <h3>联系方式</h3>
            <p>邮箱：wangcongding@lite-smart.com</p>
            <p>武汉：湖北省武汉市东湖新技术开发区高新大道999号未来科技城海外人才大楼B4-608室</p>
          </div>
        </div>
        <div class="footer-bottom">
          <p>© 2026 轻鸿数智科技有限公司 版权所有</p>
          <p class="icp-info">
            <img src="@/assets/images/icp.png" alt="ICP备案" class="icp-icon" />
            鄂ICP备2026014928号
          </p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, nextTick } from 'vue'

const mobileNavActive = ref(false)
const imageModalVisible = ref(false)
const modalImageSrc = ref('')
const header = ref(null)
const news = ref([])

const toggleMobileNav = () => {
  mobileNavActive.value = !mobileNavActive.value
}

const handleScroll = () => {
  if (header.value) {
    if (window.scrollY > 50) {
      header.value.classList.add('scrolled')
    } else {
      header.value.classList.remove('scrolled')
    }
  }
}

const scrollToSection = (sectionId) => {
  const section = document.getElementById(sectionId)
  if (section) {
    section.scrollIntoView({ behavior: 'smooth' })
  }
  mobileNavActive.value = false
}

const openImageModal = (src) => {
  // 替换@/assets路径为正确的相对路径
  modalImageSrc.value = src.replace('@/assets', 'src/assets')
  imageModalVisible.value = true
  // 禁止背景滚动
  document.body.style.overflow = 'hidden'
}

const closeImageModal = () => {
  imageModalVisible.value = false
  // 恢复背景滚动
  document.body.style.overflow = 'auto'
}



const initCarousel = () => {
  const carouselSlides = document.querySelectorAll('.carousel-slide')
  const carouselIndicators = document.querySelectorAll('.carousel-indicator')
  const prevBtn = document.querySelector('.carousel-prev')
  const nextBtn = document.querySelector('.carousel-next')
  let currentIndex = 0

  function showSlide(index) {
    carouselSlides.forEach((slide, i) => {
      slide.classList.toggle('active', i === index)
    })
    carouselIndicators.forEach((indicator, i) => {
      indicator.classList.toggle('active', i === index)
    })
    currentIndex = index
  }

  function nextSlide() {
    let nextIndex = currentIndex + 1
    if (nextIndex >= carouselSlides.length) {
      nextIndex = 0
    }
    showSlide(nextIndex)
  }

  function prevSlide() {
    let prevIndex = currentIndex - 1
    if (prevIndex < 0) {
      prevIndex = carouselSlides.length - 1
    }
    showSlide(prevIndex)
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', prevSlide)
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', nextSlide)
  }

  carouselIndicators.forEach((indicator, index) => {
    indicator.addEventListener('click', () => {
      showSlide(index)
    })
  })

  // 自动轮播
  setInterval(nextSlide, 5000)
}

const loadNews = async () => {
  try {
    // 从news.json文件中读取数据
    const response = await fetch('../views/dynamic/news.json')
    if (!response.ok) {
      throw new Error('Failed to load news data')
    }
    const data = await response.json()
    // 为每个新闻项添加相对链接
    news.value = data.map(item => ({
      ...item,
      link: `../${item.link}`
    }))
  } catch (error) {
    console.error('Error loading news:', error)
    // 加载失败时使用默认数据
    news.value = [
      {
        id: '20260403',
        date: '2026-04-03',
        title: '赋能工业智联，深耕交互创新——武汉轻鸿公司亮相2026 ITES深圳工业展',
        content: '2026年3月31日-4月3日，第27届ITES深圳国际工业制造技术及设备展览会在深圳国际会展中心（宝安）盛大启幕。作为聚焦OpenHarmony OS研发与轻智能产品技术创新的软件企业，武汉轻鸿数智科技有限公司（以下称“我司”）携核心技术成果与行业解决方案精彩参展，在这场汇聚1500+参展企业、130000+海内外专业观众的工业盛会中，展现开源鸿蒙生态实力，与行业伙伴共探工业智能化升级新路径。',
        link: '../views/dynamic/20260403/index.html'
      }
    ]
  }
}

onMounted(() => {
  // 监听滚动事件
  window.addEventListener('scroll', handleScroll)
  // 加载公司动态
  loadNews()
  // 初始化轮播图
  nextTick(() => {
    initCarousel()
  })
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
})
</script>

<style scoped>
/* 企业介绍模块样式 */
.company-intro {
  padding: 60px 0;
  background-color: #f9f9f9;
}

.intro-content {
  display: flex;
  align-items: stretch;
  gap: 40px;
}

.intro-image {
  flex: 1;
  max-width: 40%;
}

.carousel-container {
  position: relative;
  height: 100%;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.carousel-slides {
  position: relative;
  height: 100%;
}

.carousel-slide {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  transition: opacity 0.5s ease;
}

.carousel-slide.active {
  position: relative;
  opacity: 1;
}

.carousel-slide img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.carousel-controls {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  transform: translateY(-50%);
  display: flex;
  justify-content: space-between;
  padding: 0 10px;
}

.carousel-controls button {
  background-color: rgba(255, 255, 255, 0.7);
  border: none;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  font-size: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.3s ease;
}

.carousel-controls button:hover {
  background-color: rgba(255, 255, 255, 0.9);
}

.carousel-indicators {
  position: absolute;
  bottom: 10px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  gap: 8px;
}

.carousel-indicator {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.5);
  border: none;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.carousel-indicator.active {
  background-color: rgba(255, 255, 255, 0.9);
}

.intro-text {
  flex: 1;
  max-width: 60%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.intro-text p {
  margin-bottom: 16px;
  line-height: 1.6;
  font-size: 16px;
  color: #333;
  text-align: left;
  text-indent: 2em;
}

.intro-text p:last-child {
  margin-bottom: 0;
}

/* 产品矩阵模块样式 */
.product-cards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
  margin-top: 30px;
}

.product-card {
  background-color: #fff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.product-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

.product-image {
  margin-bottom: 16px;
  text-align: center;
}

.product-image img {
  max-width: 100%;
  height: 120px;
  object-fit: contain;
  border-radius: 4px;
}

.product-card h3 {
  margin-bottom: 12px;
  font-size: 18px;
  color: #0C2D4F;
}

.product-card p {
  font-size: 14px;
  line-height: 1.5;
  color: #666;
  margin: 0;
}

/* 荣誉资质模块样式 */
.honor-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
  margin-top: 30px;
}

.honor-item {
  background-color: #fff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  text-align: center;
}

.honor-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

.honor-image {
  margin-bottom: 16px;
  text-align: center;
}

.honor-image img {
  max-width: 100%;
  height: 80px;
  object-fit: contain;
  border-radius: 4px;
}

.honor-item h3 {
  font-size: 16px;
  color: #0C2D4F;
  margin: 0;
  line-height: 1.4;
}

/* Hero 特性样式 */
.hero-features {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 20px;
  margin-top: 40px;
}

.feature-card {
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  padding: 20px;
  text-align: center;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.feature-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
}

.feature-icon {
  margin-bottom: 16px;
  display: flex;
  justify-content: center;
}

.feature-card h3 {
  margin-bottom: 8px;
  font-size: 18px;
  color: #fff;
}

.feature-card p {
  font-size: 14px;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.8);
  margin: 0;
}



/* 联系我们模块样式 */
.contact-cards {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 30px;
  margin-top: 60px;
}

.contact-card {
  background-color: var(--light-blue);
  border-radius: 12px;
  padding: 40px 30px;
  box-shadow: var(--shadow);
  border: 1px solid var(--border-color);
  transition: all 0.3s ease;
  flex: 1;
  min-width: 300px;
  max-width: 400px;
  text-align: center;
  position: relative;
  overflow: hidden;
}

.contact-card:hover {
  transform: translateY(-10px);
  box-shadow: var(--shadow-hover);
  border-color: var(--secondary-color);
}

.contact-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background: linear-gradient(90deg, var(--secondary-color), var(--primary-color));
  transform: scaleX(0);
  transition: transform 0.3s ease;
}

.contact-card:hover::before {
  transform: scaleX(1);
}

.card-icon {
  width: 80px;
  height: 80px;
  background-color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
  box-shadow: var(--shadow);
  transition: all 0.3s ease;
}

.contact-card:hover .card-icon {
  transform: scale(1.1);
  box-shadow: 0 8px 20px rgba(28, 111, 180, 0.2);
}

.contact-card h3 {
  margin-bottom: 15px;
  color: var(--primary-color);
  font-size: 18px;
  font-weight: 600;
}

.contact-card p {
  margin-bottom: 20px;
  color: var(--text-light);
  line-height: 1.6;
  font-size: 14px;
}

.contact-link {
  display: inline-block;
  padding: 10px 20px;
  background-color: var(--secondary-color);
  color: white;
  border-radius: 25px;
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.contact-link:hover {
  background-color: var(--primary-color);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(28, 111, 180, 0.3);
}

/* 备案号样式 */
.icp-info {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 8px;
}

.icp-icon {
  width: 16px;
  height: 16px;
  object-fit: contain;
}

/* 公司动态模块样式 */
.company-news {
  padding: 60px 0;
  background-color: #f9f9f9;
}

.news-cards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
  margin-top: 30px;
}

.news-card {
  background-color: #fff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.news-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

.news-date {
  color: #666;
  font-size: 14px;
  margin-bottom: 12px;
}

.news-card h3 {
  margin-bottom: 12px;
  font-size: 18px;
  color: #0C2D4F;
  line-height: 1.4;
}

.news-card p {
  font-size: 14px;
  line-height: 1.5;
  color: #666;
  margin-bottom: 16px;
  flex-grow: 1;
}

.news-link {
  display: inline-block;
  color: #1C6FB4;
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  transition: color 0.3s ease;
  margin-top: auto;
  align-self: flex-start;
}

.news-link:hover {
  color: #0C2D4F;
}

.news-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 60px 0;
  color: #666;
  font-size: 16px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .intro-content {
    flex-direction: column;
    text-align: center;
  }

  .intro-image,
  .intro-text {
    max-width: 100%;
  }

  .intro-image {
    margin-bottom: 20px;
    height: 300px;
  }

  .intro-text p {
    text-align: left;
  }

  .product-cards,
  .news-cards {
    grid-template-columns: 1fr;
  }

  .icp-info {
    flex-direction: column;
    gap: 4px;
  }
}
</style>